import { Stack, Flex } from "@mantine/core";
import { ReactComponent as CommunicationIcon } from "../../../assets/icons/communication.svg";
import { ReactComponent as Gmail } from "../../../assets/tools/gmail.svg";
import { ReactComponent as Outlook } from "../../../assets/tools/outlook.svg";
import { ReactComponent as Slack } from "../../../assets/tools/slack.svg";
import { ReactComponent as Teams } from "../../../assets/tools/teams.svg";
import CustomCard from "../../Elements/Card/Card";
import SectionTitle from "../../Elements/SectionTitle/SectionTitle";
import "./CommunicationTools.css";

const CommunicationTools: React.FC = () => {
  const openApp = (protocolUrl: string, fallbackUrl: string) => {
    let appOpened = false;
    const timeout = setTimeout(() => {
      if (!appOpened) {
        window.open(fallbackUrl, "_blank");
      }
    }, 2000);

    try {
      window.location.href = protocolUrl;
      window.addEventListener("blur", () => {
        appOpened = true;
        clearTimeout(timeout);
      });
      window.addEventListener("focus", () => {
        clearTimeout(timeout);
      });
    } catch (error) {
      console.error("Error opening app: ", error);
      clearTimeout(timeout);
      window.open(fallbackUrl, "_blank");
    }
  };

  return (
    <Stack className="w-full" gap="0.5rem">
      <Flex
        direction={{ base: 'column', md: 'row' }}
        justify={{ base: "flex-start", lg: "center" }}
        gap="2rem"
        wrap="wrap"
      >
        <Flex direction="column" gap="0.5rem">
          <SectionTitle
            Icon={CommunicationIcon}
            title="Internal Communication Tools"
          />
          <CustomCard className="!flex-row gap-4 !cursor-default">
            <div
              className="communication-tool-section"
              onClick={() =>
                openApp("outlook://", "https://outlook.office.com")
              }
            >
              <Outlook />
            </div>
            <div
              className="communication-tool-section"
              onClick={() => openApp("teams://", "https://teams.office.com")}
            >
              <Teams />
            </div>
          </CustomCard>
        </Flex>
        <Flex direction="column" gap="0.5rem">
          <SectionTitle
            Icon={CommunicationIcon}
            title="Client Communication Tools"
          />
          <CustomCard className="!flex-row gap-4 !cursor-default">
            <div
              className="communication-tool-section"
              onClick={() => window.open("https://mail.google.com/", "_blank")}
            >
              <Gmail />
            </div>
            <div
              className="communication-tool-section"
              onClick={() => openApp("slack://", "https://slack.com/signin")}
            >
              <Slack />
            </div>
          </CustomCard>
        </Flex>
      </Flex>
    </Stack>
  );
};

export default CommunicationTools;
